import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { ProjectSecurityContext } from 'domain/shared/newProject';
import { useShowContext } from 'framework/show';
import NotesWrapper from '../../dashboard/shared/staffingContent/notes/NotesWrapper';
import RequiredPositionsWrapper from '../opportunityContent/requiredPositions/RequiredPositionsWrapper';
import { Box } from '@mui/material';

const OpportunityDashboardExpandedContent = () => {
  const { isFeatureEnabled } = useFeatureToggle();

  const { data } = useShowContext();

  return (
    <ProjectSecurityContext permissions={data.accessInfo}>
      <Box pb={2}>
        {isFeatureEnabled(Features.STAFFING_ASSIGNMENTS) && <RequiredPositionsWrapper />}
        {isFeatureEnabled(Features.OPPORTUNITY_DASHBOARD) && <NotesWrapper />}
      </Box>
    </ProjectSecurityContext>
  );
};

export default OpportunityDashboardExpandedContent;
